/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Not_FoundInputs */

const cs_demands_not_found = /** @type {(inputs: Demands_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka nenalezena.`)
};

const en_demands_not_found = /** @type {(inputs: Demands_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand not found.`)
};

/**
* | output |
* | --- |
* | "Demand not found." |
*
* @param {Demands_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_not_found = /** @type {((inputs?: Demands_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_not_found(inputs)
	return cs_demands_not_found(inputs)
});